/* eslint-disable @angular-eslint/prefer-inject */
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { GoalStatisticsService } from '../../service/statistics/statistics.service';
import { GoalStatistics } from '@app/goal/model/statistics.model';
import { ThemeService } from '@app/shared/service/theme.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-goal-line-goal',
    templateUrl: './line-goal.component.html',
    styleUrls: ['./line-goal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalLineGoalComponent implements OnInit, OnDestroy {
    @Input() withTitle = true;

    /**
     * Subscriptions
     */
    private subscriptions = new Subscription();

    constructor(
        private goalStatisticsService: GoalStatisticsService,
        private changeDetectorRef: ChangeDetectorRef,
        private themeService: ThemeService,
    ) {}

    ngOnInit() {
        this.subscriptions.add(this.goalStatisticsService.updates.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    get statistics(): GoalStatistics {
        return this.goalStatisticsService.statistics;
    }

    /**
     * Complete percentage
     */
    get percentComplete(): number {
        const percentComplete = Math.floor((this.statistics.goal.current.seconds / this.statistics.goal.declarated.seconds) * 1000) / 10;
        return percentComplete > 100 ? 100 : percentComplete;
    }

    /**
     * Completed Flag
     */
    get completed(): boolean {
        return this.percentComplete === 100;
    }

    /**
     * Goal Was started Flag
     */
    get started(): boolean {
        return this.statistics.goal.current.seconds > 0;
    }

    get isNewThemeSet$() {
        return this.themeService.currentTheme$.pipe(map((theme: any) => theme.id === 'new'));
    }
}
